import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/apiClient';
import type { ApiResponse } from '@/types/api';

/**
 * The OmnibizChat app's install link on Shopify, or null until the Shopify app exists. Until then
 * the dashboard asks for the store's address instead.
 */
export function useShopifyInstallUrl(): string | null {
  const { data } = useQuery({
    queryKey: ['shopify', 'config'],
    queryFn: () =>
      apiClient
        .get<ApiResponse<{ installUrl: string | null }>>('/api/shopify/config')
        .then((res) => res.data.data?.installUrl ?? null),
    staleTime: Infinity,
    retry: false,
  });
  return data ?? null;
}
